(() => {
  // Subscription button clicks
  document.addEventListener('click', (e) => {
    const el = e.target.closest('[data-change-to="Subscription"]');
    if (!el) return;
    if (typeof window.saq !== 'undefined') {
      console.log('Calling saq qmiTsC0aGCZOd012elyvBs');
      window.saq('conv', 'qmiTsC0aGCZOd012elyvBs');
    }
  });

  // One-off button clicks
  document.addEventListener('click', (e) => {
    const el = e.target.closest('[data-change-to="One-off"]');
    if (!el) return;
    if (typeof window.saq !== 'undefined') {
      console.log('Calling saq qyAxlQhQmnUKavYa5L6t9f');
      window.saq('conv', 'qyAxlQhQmnUKavYa5L6t9f');
    }
  });

  // Newsletter submit
  document.addEventListener('click', (e) => {
    const el = e.target.closest('.newsletter-form__button');
    if (!el) return;
    if (typeof window.saq !== 'undefined') {
      console.log('Calling saq kc06zXBQDfcN319hIC6tHM');
      window.saq('conv', 'kc06zXBQDfcN319hIC6tHM');
    }
  });

  // Other anchors
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a');
    if (!a) return;

    const href = a.getAttribute('href') || '';
    const text = (a.textContent || '').trim();
    const lowercaseText = text.toLowerCase();

    // console.log({ href, text, lowercaseText });

    if (typeof window.saq !== 'undefined') {
      // 1800 call
      if (href.includes('tel:1800')) {
        console.log('Calling saq EOfRHRMhBUk7hEx6RRwHGS');
        window.saq('conv', 'EOfRHRMhBUk7hEx6RRwHGS');
      }

      // Product button clicks
      switch (lowercaseText) {
        case 'small sized custom box':
          console.log('Calling saq PEKEm1W50dqeJplT7NDqMR');
          window.saq('conv', 'PEKEm1W50dqeJplT7NDqMR');
          break;
        case 'medium sized custom box':
          console.log('Calling saq 2OdCJJN15EvMtjMtJABrZF');
          window.saq('conv', '2OdCJJN15EvMtjMtJABrZF');
          break;
        case 'large sized custom box':
          console.log('Calling saq gm1uYuQXe6ChkHoOr9UUIK');
          window.saq('conv', 'gm1uYuQXe6ChkHoOr9UUIK');
          break;
        case 'jumbo sized custom box':
          console.log('Calling saq nPeSEWWM1gILbBmRsERE6z');
          window.saq('conv', 'nPeSEWWM1gILbBmRsERE6z');
          break;
      }
    }
  });
})();
